import { render, staticRenderFns } from "./TeacherRecordRateList.vue?vue&type=template&id=1ebb373b&scoped=true"
import script from "./TeacherRecordRateList.vue?vue&type=script&lang=js"
export * from "./TeacherRecordRateList.vue?vue&type=script&lang=js"
import style0 from "./TeacherRecordRateList.vue?vue&type=style&index=0&id=1ebb373b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebb373b",
  null
  
)

export default component.exports